const STORAGE_KEY = 'video_playback_records_v1'
const MAX_RECORDS = 100

function readRecords () {
  if (typeof localStorage === 'undefined') return {}
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : {}
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
  } catch {
    return {}
  }
}

function writeRecords (records) {
  if (typeof localStorage === 'undefined') return
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(records || {}))
  } catch {
    // ignore storage quota / private mode errors
  }
}

function trimRecords (records) {
  const entries = Object.entries(records || {})
  if (entries.length <= MAX_RECORDS) return records

  return Object.fromEntries(
    entries
      .sort((a, b) => Number(b[1]?.updateTime || 0) - Number(a[1]?.updateTime || 0))
      .slice(0, MAX_RECORDS)
  )
}

export function getPlaybackRecord (dramaId) {
  if (dramaId == null || dramaId === '') return null
  const records = readRecords()
  const record = records[String(dramaId)]
  return record && typeof record === 'object' ? record : null
}

export function savePlaybackProgress ({ dramaId, episodeId, startTime }) {
  if (dramaId == null || dramaId === '' || episodeId == null || episodeId === '') return

  const safeTime = Math.max(0, Math.floor(Number(startTime) || 0))
  if (safeTime <= 0) return

  const records = readRecords()
  records[String(dramaId)] = {
    startTime: safeTime,
    startTimeEpisodeId: String(episodeId),
    updateTime: Date.now()
  }
  writeRecords(trimRecords(records))
}

export function clearPlaybackRecords () {
  if (typeof localStorage === 'undefined') return
  localStorage.removeItem(STORAGE_KEY)
}
